<template>
  <div id="tableFicha"> 
  <template  v-if="selected.length">
    <div>
      <!-- Aqui se insatnacia el modal -->
  <b-modal visible id="modal-lg" size="lg" centered title="Ficha del libro"
          header-text-variant="light"
          body-bg-variant="light"
          body-text-variant="dark"
          footer-bg-variant="#F1EBD5"> 
          <b-container fluid>
            <b-row class="mb-2">
              <b-col> <span id="numFicha">Ficha núm: </span> <span id="valorNumFicha">{{selected[0].Ficha_No}}</span>
              <span id="clasifi" >{{selected[0].Clasificacion}}</span> 
              </b-col>
            </b-row>
              <b-row class="mb-1">
                <b-col>{{selected[0].EtiquetasMARC}}</b-col>
              </b-row>
              <b-row class="mb-1 colorBlue"> 
                <b-col>ISBN {{selected[0].ISBN}} </b-col>
              </b-row>
              <b-row class="mb-1 colorBlue">
                <b-col> {{selected[0].Titulo}}</b-col>
              </b-row>
              <b-row class="mb-1 colorBlue">
                <b-col>{{selected[0].Autor}}</b-col>
              </b-row>
              <b-row class="mb-1 colorBlue">
                <b-col>{{selected[0].Nombre}}</b-col>
              </b-row>
          </b-container>
    </b-modal>
    </div>

  </template> 
      <!--<p> Se encontraron: {{rows}} registros </p> -->


      <!--<p> Se crea la instancia de la tabla-->
    <b-table :busy="busys" stacked="md" striped small head-variant="light"  ref="selectableTable" selectable 
    :items="datosResult" :fields="fields" :select-mode="selectMode" responsive="sm" :per-page="perPage" 
    :current-page="currentPage" @row-selected="onRowSelected">
      <template #table-busy>
        <div class="text-center  my-2" style="color linear-gradient(to left, #003595, #1D71B8);">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        
      </template>
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
    </b-table>
    <!-- Paginador de la tabla  -->
    <div v-if="datosResult.length >= 101" class="overflow-auto" >
    <b-pagination 
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      align="right"
    ></b-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ListaSelect',
    props: {
        datosResult: [],
        busys:Boolean,
    },
    computed:{
        selecionado: function(){
            if (window.innerWidth){
               return true 
            }
            else 
               return false 
            },
        rows() {
           return this.datosResult.length
            },    
    },

    mounted() {
       // console.log (window.innerWidth);
    },

    data() {
      return {
        fields: 
        ['Selected', 
        {key: 'Titulo', label: 'Título', sortable: true},
        {key: 'Autor', label: 'Autor', sortable: true},
        {key: 'Clasificacion', label: 'Clasificación', sortable: true},
        ],
        selectMode: 'single',
        selected: [],
        perPage: 10,
        currentPage: 1,
      }
    },
    methods: {
      onRowSelected(items) {
        this.selected = items
      },
   
    }
  }
</script>

<style scoped>


#tableFicha{
   font-size: 1.6rem;
   margin-bottom: 70px;
}
.b-table-sticky-header, .table-responsive, [class*=table-responsive-] {
    margin-bottom: 2rem;
    margin-top: 3rem;
}
.pagination {
    border-radius: 1.5rem;
    
} 
@media (max-width: 480px) {
  #tableFicha {
   font-size: 1.2rem;
   margin-bottom: 60px;
  }

  
}
</style>